import composedPath from './helpers/composedPath'

export default class {
  constructor() {
    const toggable = document.querySelectorAll('*[data-toggle]')
    for (let i = 0; i < toggable.length; i++) {
      toggable[i].addEventListener('click', this.toggleElement.bind(this))
    }
    document.addEventListener('keydown', this.onKeyDown.bind(this))
    this.triggers = []
    this.modalElements = []
  }

  addTrigger(key, fn) {
    this.triggers[key] = fn
  }

  toggleElement(event) {
    let originalTarget = event.target
    let target = originalTarget
    let className = 'toggled'
    const path = composedPath(event)

    if (!target.hasAttribute('data-toggle')) {
      // Catch inside Links
      if (target.tagName === 'A') {
        return
      }

      for (let i = 0; i < path.length; i++) {
        const parentElement = path[i]
        if (parentElement.hasAttribute('data-toggle')) {
          target = parentElement
          originalTarget = parentElement
          break
        }
      }
    }

    if (target.hasAttribute('data-class')) {
      className = target.getAttribute('data-class')
    }

    if (target.hasAttribute('data-parent')) {
      if (target.getAttribute('data-parent') === '') {
        target = target.parentNode
      } else if (target.getAttribute('data-parent') === 'body') {
        target = document.body
      } else {
        for (let i = 0; i < path.length; i++) {
          const parentElement = path[i]
          if (
            parentElement &&
            parentElement.classList &&
            parentElement.classList.contains(target.getAttribute('data-parent'))
          ) {
            target = parentElement
            break
          }
        }
      }
    }

    if (
      originalTarget.hasAttribute('data-trigger') &&
      this.triggers[originalTarget.getAttribute('data-trigger')]
    ) {
      this.triggers[originalTarget.getAttribute('data-trigger')](
        originalTarget,
        target,
      )
    }

    if (originalTarget.hasAttribute('data-modal')) {
      this.modalElements.push({
        target,
        className,
      })
    }
    if (originalTarget !== target) {
      this.toggleClass(originalTarget, 'toggled')
    }
    this.toggleClass(target, className)
  }

  toggleClass(el, className) {
    if (el.classList.contains(className)) {
      el.classList.remove(className)
    } else {
      el.classList.add(className)
    }
  }

  onKeyDown(event) {
    if (event.code === 'Escape') {
      for (let i = 0; i < this.modalElements.length; i++) {
        // this.modalElements[i].target.classList.remove(modal.className)
      }
    }
  }
}
